import React from 'react';
import styled from 'styled-components';

const BorderLayout = styled.div`
  position: fixed;
  z-index: 999999;
  pointer-events: none;
`;
const BorderUp = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  padding: 10px;
  @media (max-width: 576px) {
    padding: 5px;
  }
  left: 0;
  background: #3f3f3f;
`;
const BorderRight = styled.div`
  position: fixed;
  right: 0;
  padding: 10px;
  @media (max-width: 576px) {
    padding: 5px;
  }
  height: 100%;
  top: 0;
  background: #3f3f3f;
`;
const BorderLeft = styled.div`
  position: fixed;
  left: 0;
  padding: 10px;
  @media (max-width: 576px) {
    padding: 5px;
  }
  height: 100%;
  top: 0;
  background: #3f3f3f;
`;
const BorderDown = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px;
  @media (max-width: 576px) {
    padding: 5px;
  }
  left: 0;
  background: #3f3f3f;
`;

function Borders() {
  return (
    <BorderLayout>
      <BorderUp />
      <BorderLeft />
      <BorderDown />
      <BorderRight />
    </BorderLayout>
  );
}

export default Borders;
